import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class UserPermissionsService {
    private serverUrl = 'https://' + window.location.host;
    private version = '0.5';
    private _url = (this.serverUrl + '/api/v{version}/userpermissionset').replace(
        '{version}',
        this.version
    );

    constructor(private http: HttpClient) {}

    getPermissionSets(): Observable<any[]> {
        return this.http.get<any[]>(`${this._url}/sets`);
    }

    getPermissionSetName(permissionName: string): Observable<any[]> {
        const params = new HttpParams().set('permissionName', permissionName);
        return this.http.get<any[]>(`${this._url}/nameSets`, { params: params });
    }

    getClientPermissionSet(): Observable<any[]> {
        return this.http.get<any[]>(`${this._url}`);
    }

    addPermissionSet(inputName, inputDesc): Observable<any> {
        let data = {
            name: inputName,
            description: inputDesc,
        };
        return this.http.post(`${this._url}/set`, data);
    }

    getUsersAssigned(permissionSetKey): Observable<any[]> {
        const params = new HttpParams().set('permissionSetKey', permissionSetKey.toString());

        return this.http.get<any[]>(`${this._url}/set/assigned`, { params: params });
    }

    deletePermissionSet(permissionSetKey: number): Observable<any> {
        return this.http.post(`${this._url}/delete`, permissionSetKey);
    }

    getPermissionSetPages(permissionSetKey: number): Observable<PermissionSetPage[]> {
        const params = new HttpParams().set('permissionSetKey', permissionSetKey.toString());
        return this.http.get<PermissionSetPage[]>(`${this._url}/pages`, {
            params: params,
        });
    }

    getHomePages(permissionSetKey: number): Observable<any[]> {
        const params = new HttpParams().set('permissionSetKey', permissionSetKey.toString());
        return this.http.get<any[]>(`${this._url}/pages/home`, {
            params: params,
        });
    }

    updatePermissionSetPages(
        name: string,
        key: number,
        pages: PermissionSetUpdateForm[]
    ): Observable<any> {
        let dataBody = {
            name: name,
            permissionSetKey: key,
            pages: pages,
        };
        return this.http.post(`${this._url}/pages`, dataBody);
    }

    getEmployeeAssignment(): Observable<any[]> {
        return this.http.get<any[]>(`${this._url}/assignment`);
    }

    getPositionPermissionSets(): Observable<any[]> {
        return this.http.get<any[]>(`${this._url}/position`);
    }

    getPositionDefaults(position: string): Observable<any> {
        const params = new HttpParams().set('position', position);
        return this.http.get<any[]>(`${this._url}/position/name`, {
            params: params,
        });
    }

    updatePositionPermissionSets(body): Observable<any> {
        return this.http.post(`${this._url}/position`, body);
    }
}

export interface PermissionSetPage {
    applicationPageKey: number;
    name: string;
    routerURL: string;
    hasPage: boolean;
    applicationPageTypeKey: number;
    parentApplicationPageKey?: number;
    permissionSetPageKey?: number;
    isDeleted?: boolean;
    icon: string;
    module?: string;
}

export interface PermissionSetUpdateForm {
    permissionSetKey: number;
    applicationPageKey: number;
    isActive: boolean;
}

export interface Module {
    page: PermissionSetPage;
    pages: PermissionSetPage[] | Module[];
}

export interface PositionPermissionUpdate {
    staffPositionKey: number;
    permissionSetKey: string;
    roleName: string;
    isActive: boolean;
    homePageKey: number;
}
